import { RoundedPlane, ViewerModule } from "@g.frame/core";
import { Color, Vector2 } from "three";
const styleConfig = {
    radius: 0.13,
    shadowHeight: 0.04,
    size: new Vector2(3.38, .26),
    current: {
        bar: {
            color: new Color('#F8D669'),
        },
        shadow: {
            color: new Color('#E2B522'),
        }
    },
    max: {
        bar: {
            color: new Color('#EEF7FC'),
        },
        shadow: {
            color: new Color('#CFE8F9'),
        }
    }
};
export default class TaskProgressBar extends ViewerModule {
    constructor() {
        super();
        this.current = {
            bar: undefined,
            shadow: undefined
        };
        this.max = {
            bar: undefined,
            shadow: undefined
        };
    }
    set(options) {
        this.options = options;
        this.options.scale = this.options.scale || 1;
        this.current.bar && this.disposeObject(this.current.bar);
        this.current.shadow && this.disposeObject(this.current.shadow);
        this.max.bar && this.disposeObject(this.max.bar);
        this.max.shadow && this.disposeObject(this.max.shadow);
        if (this.options.value) {
            if (this.options.value === 1) {
                this.current = this.getShadowedBar();
            }
            else {
                this.current = this.getShadowedBar();
                this.max = this.getShadowedBar(false);
            }
        }
        else {
            this.max = this.getShadowedBar(false);
        }
    }
    getShadowedBar(current = true) {
        const type = current ? 'current' : 'max';
        const barOptions = {
            width: styleConfig.size.x * (current ? this.options.value : 1),
            height: styleConfig.size.y,
            color: styleConfig[type].bar.color.getHex(),
            r1: styleConfig.radius,
        };
        const shadowOptions = {
            width: styleConfig.size.x * (current ? this.options.value : 1),
            height: styleConfig.size.y + styleConfig.shadowHeight,
            color: styleConfig[type].shadow.color.getHex(),
            r1: styleConfig.radius,
        };
        const bar = RoundedPlane.getRoundedPlane(barOptions);
        const shadow = RoundedPlane.getRoundedPlane(shadowOptions);
        bar.scale.setScalar(this.options.scale);
        shadow.scale.setScalar(this.options.scale);
        this.addObject(bar);
        this.addObject(shadow);
        const shadowY = -styleConfig.shadowHeight * this.options.scale;
        if (current) {
            const x = (-.5 + this.options.value / 2) * this.options.scale * styleConfig.size.x;
            bar.position.set(x, 0, 0);
            shadow.position.set(x, shadowY, -.001);
        }
        else {
            bar.position.set(0, 0, -.002);
            shadow.position.set(0, shadowY, -.003);
        }
        return {
            bar: bar,
            shadow: shadow
        };
    }
}
